import React, { useEffect, useRef, useState, useCallback } from "react";
import { observer } from "mobx-react";
import Loader from "../util/Loader";
import Product from "./Product";
import ProductAd from "./ProductAd";

const Products = observer(({ products, crossSellProducts, ad, loadMoreProducts, hasMoreProducts = false, categoryId = 1}) => {
  const [isLoading, setIsLoading] = useState(false);
  const observerRef = useRef(null);

  const handleIntersection = useCallback((entries) => {
    const firstEntry = entries[0];
    if (firstEntry.isIntersecting && !isLoading && loadMoreProducts) {
      setIsLoading(true);
      loadMoreProducts();
    }
  }, [isLoading, loadMoreProducts]);

  useEffect(() => {
    const currentObserverRef = observerRef.current;
    const observer = new IntersectionObserver(handleIntersection, { threshold: 0.25, rootMargin: "30px" });

    if (currentObserverRef) {
      observer.observe(currentObserverRef);
    }

    return () => {
      if (currentObserverRef) {
        observer.unobserve(currentObserverRef);
      }
    };
  }, [handleIntersection]);

  useEffect(() => {
    setIsLoading(false); // Stop showing the loading indicator once products are updated
  }, [products]);

  if (!products) return null;

  return (
    <div className="w-full pt-3 md:pt-6 pb-0 md:pb-16">
      <div className="md:grid md:grid-cols-[repeat(auto-fill,minmax(210px,1fr))] lg:gap-7 md:gap-4">
        {products.map((product, index) => (
          <React.Fragment key={product?.id + '-' + categoryId}>
            <Product product={product} crossSellProducts={crossSellProducts} />
            {index === 3 && <ProductAd ad={ad} />}
          </React.Fragment>
        ))}
      </div>
      <div ref={observerRef} className="h-[50.5rem] pt-[35rem] mt-[-49rem] md:mt-[-45.5rem]" />
      {(isLoading && hasMoreProducts) && <div className="text-center relative"><Loader /></div>}
    </div>
  );
});

export default Products;